module.exports = __webpack_public_path__ + "img/cubemars.bc9718f1.png";